<template>
  <b-row>
    <b-col md="12">
      <b-form-group >
        <b-form-select
          id="order"
          :class="sortDropdownClass"
          size="sm"
          v-model="selectedSortMethod"
          :options="sortMethods"
          @change="$emit('sort', selectedSortMethod)"
          ></b-form-select>
      </b-form-group>
    </b-col>
    <!-- <b-col md="12">
      <hr style="margin-block: .25rem;">
      <b-form-group>
        <b-form-select
          id="itemsPerPage"
          size="sm"
          v-model="selectedResultsPerPage"
          :options="resultsPerPage"
          @change="$emit('pagination', selectedResultsPerPage)"
          >
          </b-form-select>
      </b-form-group>
    </b-col> -->
    <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
        v-b-toggle.collapse-hotel-types >
        <translate>Hotel types</translate>
        <b-icon
          @click="collapsed.hotelTypes = !collapsed.hotelTypes"
          :icon="collapsed.hotelTypes ? 'chevron-down' : 'chevron-up'"
        />
      </div>
      <b-collapse id="collapse-hotel-types" class="mt-2" visible>
        <b-form-checkbox-group
          v-model="selectedHotelTypesCopy"
          :options="hotelTypes"
          text-field="label"
          value-field="id"
          @change="$emit('hotelTypesChange', selectedHotelTypesCopy)"
          stacked
          switches
          >
        </b-form-checkbox-group>
      </b-collapse>
    </b-col>
    <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
        v-b-toggle.collapse-hotel-amenities >
        <translate>Hotel amenities</translate>
        <b-icon
          @click="collapsed.hotelAmenities = !collapsed.hotelAmenities"
          :icon="collapsed.hotelAmenities ? 'chevron-down' : 'chevron-up'"
        />
      </div>
      <b-collapse id="collapse-hotel-amenities" class="mt-2" visible>
        <b-form-checkbox-group
          v-model="selectedHotelAmenitiesCopy"
          :options="hotelAmenities"
          text-field="label"
          value-field="id"
          @change="$emit('hotelAmenitiesChange', selectedHotelAmenitiesCopy)"
          stacked
          switches
          >
        </b-form-checkbox-group>
      </b-collapse>
    </b-col>
    <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
        v-b-toggle.collapse-room-amenities >
        <translate>Room amenities</translate>
        <b-icon
          @click="collapsed.roomAmenities = !collapsed.roomAmenities"
          :icon="collapsed.roomAmenities ? 'chevron-down' : 'chevron-up'"
        />
      </div>
      <b-collapse id="collapse-room-amenities" class="mt-2" visible>
        <b-form-checkbox-group
          v-model="selectedRoomAmenitiesCopy"
          :options="roomAmenities"
          text-field="label"
          value-field="id"
          @change="$emit('roomAmenitiesChange', selectedRoomAmenitiesCopy)"
          stacked
          switches
          >
        </b-form-checkbox-group>
      </b-collapse>
    </b-col>
    <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
        v-b-toggle.collapse-hotel-themes >
        <translate>Hotel themes</translate>
        <b-icon
          @click="collapsed.hotelThemes = !collapsed.hotelTypes"
          :icon="collapsed.hotelThemes ? 'chevron-down' : 'chevron-up'"
        />
      </div>
      <b-collapse id="collapse-hotel-themes" class="mt-2" visible>
        <b-form-checkbox-group
          v-model="selectedHotelThemesCopy"
          :options="hotelThemes"
          text-field="label"
          value-field="id"
          @change="$emit('hotelThemesChange', selectedHotelThemesCopy)"
          stacked
          switches
          >
        </b-form-checkbox-group>
      </b-collapse>
    </b-col>
    <!-- <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
        v-b-toggle.collapse-stars >Stars
        <b-icon
          @click="toggleCollapse('stars')"
          :icon="collapsed.stars ? 'chevron-up' : 'chevron-down'"
        />
      </div>
      <b-collapse id="collapse-stars" class="mt-2">
        <span v-for="opt in stars" :key="opt.text" class="d-flex align-items-center">
          <b-form-checkbox>
            <span v-for="star in opt.value" :key="star.value">
              <small>
                <b-icon icon="star-fill" class="text-warning" font-scale="1"/>
              </small>
            </span>
          </b-form-checkbox>
        </span>
      </b-collapse>
    </b-col> -->
    <b-col sm="12">
      <hr style="margin-block: .25rem;">
      <div class="d-flex justify-content-between"
         v-b-toggle.collapse-price >
         <span v-translate>Price range</span>
         <b-icon
          @click="collapsed.price = !collapsed.price"
          :icon="collapsed.price ? 'chevron-up' : 'chevron-down'"
          />
      </div>
      <b-collapse id="collapse-price" class="mt-2">
        <b-form-checkbox-group
          v-model="selectedPriceFiltersCopy"
          :options="priceFilters"
          @change="$emit('priceFiltersChange', selectedPriceFiltersCopy)"
          switches
          stacked
        ></b-form-checkbox-group>
      </b-collapse>
    </b-col>
  </b-row>
</template>
<script>
import formMixin from '@/app/private/shared/mixins/search_forms'

export default {
  name: 'SortFields',
  props: {
    hotelTypes: {
      type: Array,
      required: true
    },
    selectedHotelTypes: {
      type: Array,
      required: true
    },
    hotelThemes: {
      type: Array,
      required: true
    },
    selectedHotelThemes: {
      type: Array,
      required: true
    },
    hotelAmenities: {
      type: Array,
      required: true
    },
    selectedHotelAmenities: {
      type: Array,
      required: true
    },
    roomAmenities: {
      type: Array,
      required: true
    },
    selectedRoomAmenities: {
      type: Array,
      required: true
    },
    priceFilters: {
      type: Array,
      required: true
    },
    selectedPriceFilters: {
      type: Array,
      required: true
    }
  },
  mixins: [formMixin],
  data () {
    return {
      selectedHotelTypesCopy: [...this.selectedHotelTypes],
      selectedHotelThemesCopy: [...this.selectedHotelThemes],
      selectedHotelAmenitiesCopy: [...this.selectedHotelAmenities],
      selectedRoomAmenitiesCopy: [...this.selectedRoomAmenities],
      selectedPriceFiltersCopy: [...this.selectedPriceFilters],
      collapsed: {
        hotelTypes: false,
        hotelAmmenities: false,
        roomAmmenities: false,
        price: false
      }
    }
  },
  methods: {
    resetFilters () {
      this.$emit('filtersReset')
      this.selectedHotelTypesCopy = [...this.selectedHotelTypes]
      this.selectedHotelThemesCopy = [...this.selectedHotelThemes]
      this.selectedHotelAmenitiesCopy = [...this.selectedHotelAmenities]
      this.selectedRoomAmenitiesCopy = [...this.selectedRoomAmenities]
      this.selectedPriceFiltersCopy = [...this.selectedPriceFilters]
    }
  }
}

</script>

<style lang="scss">
  .btn-filters {
    .dropdown-menu.show {
      padding:.5rem;
      width: 100%;
    }
  }
</style>
